exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".text-margin{\r\n    margin-right: 5px;\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// E:/Office Projects/Paarsel/paarsel_business_web/paarsel_business_web/src/app/logistics-operations/dashboard-main/section2-1/section2-1.component.css
// module id = ../../../../../src/app/logistics-operations/dashboard-main/section2-1/section2-1.component.css
// module chunks = main